<script>
    import { onMount } from "svelte";
    import { FormGroup, Input } from "sveltestrap";
    import store from "../store";
    import { fonts, fontsStyle, fontsAlign, fontsLine } from "./fonts.js";
    import l from "../utils/locale";

    let drawFontFamily = "shape";
    let drawTextAlign = "left";
    let drawTextStyle = "---";
    let drawTextLine = "---";

    onMount(() => {
        return store.subscribe((s) => {
            drawTextLine = s.drawTextLine;
            drawTextAlign = s.drawTextAlign;
            drawTextStyle = s.drawTextStyle;
            drawFontFamily = s.drawFontFamily;
            window.fabricHelper.updateActive();
        });
    });

    function onInputHandler(e) {
        store.setValue(e.target.name, e.target.value);
    }
</script>

<div class="rangeRange">
    <FormGroup>
        <div class="leftLabel">
            {l["family"]}
        </div>
        <Input
            on:change={onInputHandler}
            bind:value={drawFontFamily}
            id="drawFontFamily"
            name="drawFontFamily"
            type="select"
            class="font-select"
            style={`font-family: ${drawFontFamily}, Helvetica, sans-serif`}
        >
            {#each fonts as font}
                <option
                    style={`font-family: ${font}, Helvetica, sans-serif`}
                    value={font}>{font}</option
                >
            {/each}
        </Input>
    </FormGroup>
</div>
<div class="rangeRange">
    <FormGroup>
        <div class="leftLabel">
            {l["align"]}
        </div>
        <Input
            on:change={onInputHandler}
            bind:value={drawTextAlign}
            id="drawTextAlign"
            name="drawTextAlign"
            type="select"
        >
            {#each fontsAlign as align}
                <option value={align}>{l[align]}</option>
            {/each}
        </Input>
    </FormGroup>
</div>

<div class="rangeRange">
    <FormGroup>
        <div class="leftLabel">
            {l["style"]}
        </div>
        <Input
            on:change={onInputHandler}
            bind:value={drawTextStyle}
            id="drawTextStyle"
            name="drawTextStyle"
            type="select"
        >
            {#each fontsStyle as fstyle}
                <option value={fstyle}>{l[fstyle]}</option>
            {/each}
        </Input>
    </FormGroup>
</div>
<div class="rangeRange">
    <FormGroup>
        <div class="leftLabel">
            {l["line"]}
        </div>
        <Input
            on:change={onInputHandler}
            bind:value={drawTextLine}
            id="drawTextLine"
            name="drawTextLine"
            type="select"
        >
            {#each fontsLine as fline}
                <option value={fline}>{l[fline]}</option>
            {/each}
        </Input>
    </FormGroup>
</div>
